import React, { useEffect, useRef, useState } from 'react';
import { recetasCarousel } from '../data/recetasCarousel';
export function RecipeCarousel() {
  const containerRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<Array<HTMLDivElement | null>>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const observer = new IntersectionObserver(entries => {
      let bestRatio = 0;
      let bestIndex: number | null = null;
      entries.forEach(entry => {
        const idx = Number((entry.target as HTMLElement).dataset.index);
        if (entry.intersectionRatio > bestRatio) {
          bestRatio = entry.intersectionRatio;
          bestIndex = idx;
        }
      });
      if (bestIndex !== null && bestRatio > 0.5) {
        setActiveIndex(bestIndex);
      }
    }, {
      root: container,
      threshold: [0.5, 0.6, 0.7, 0.8, 0.9, 1]
    });
    itemRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  const scrollToIndex = (index: number) => {
    itemRefs.current[index]?.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  };
  return <section className="w-full bg-white pb-20 pt-2" data-id="element-140" data-mp="1qm5ylzz17b4r">
      <div className="mx-auto max-w-6xl" data-id="element-141" data-mp="1qkushti45rah">
        <h2 className="px-6 text-center font-heading text-2xl font-bold text-mint-dark sm:text-3xl" data-id="element-142" data-mp="1cmwjl3mkan2d">
          Así se ven las recetas por dentro
        </h2>

        <div ref={containerRef} className="mt-10 flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth px-4 pb-1 sm:px-6 [&::-webkit-scrollbar]:hidden" style={{
        scrollbarWidth: 'none'
      }} data-id="element-143" data-mp="1hn10gurdtjt4">
          {recetasCarousel.map((receta, index) => <div key={receta.id} ref={el => {
          itemRefs.current[index] = el;
        }} data-index={index} className="w-[88%] shrink-0 snap-center sm:w-[46%] lg:w-[31%]" data-id="element-144" data-mp="2y0hdsbpmtww0" data-mpi={index}>
              <div className="aspect-square w-full overflow-hidden rounded-xl bg-gray-100" data-id="element-145" data-mp="9tivkzyl4pjj">
                <img src={receta.src} alt={receta.alt} width={1350} height={1350} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-146" data-mp="5rxcgwvgjf0w" />
              </div>
            </div>)}
        </div>

        <div className="mt-5 flex items-center justify-center gap-2" role="tablist" aria-label="Selector de receta" data-id="element-147" data-mp="tk4gmi7fcqav">
          {recetasCarousel.map((receta, index) => <button key={receta.id} type="button" role="tab" onClick={() => scrollToIndex(index)} aria-label={`Ir a la imagen de receta ${index + 1}`} aria-selected={activeIndex === index} className={`h-2 rounded-full transition-all duration-200 ease-out ${activeIndex === index ? 'w-6 bg-mint-dark' : 'w-2 bg-gray-300'}`} data-id="element-148" data-mp="jrf89w767sjr" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}